/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-duplicates */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-bitwise */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-underscore-dangle */
import {
  LoadingOutlined,
  EditOutlined,
  PhoneOutlined,
  MailOutlined,
  UserOutlined,
  IdcardOutlined,
  ShopOutlined,
  AuditOutlined,
  DeleteFilled,
  PushpinOutlined,
  HomeOutlined,
  BankOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Popconfirm,
  Row,
  Space,
  Tag,
  Tooltip,
  Typography,
} from 'antd'
import Text from 'antd/lib/typography/Text'

import React from 'react'
import {
  FiCreditCard,
  FiFile,
  FiFileText,
  FiMail,
  FiPhone,
  FiTarget,
  FiUser,
} from 'react-icons/fi'

import { translate } from '~/utils/locale'
import { Container } from './styles'

import { useParentCustomer } from '~/hooks/Clients/useParentCustomer'
import { useListParentClients } from '~/hooks/Clients/useListParentCustomer'
import NumberFormat from 'react-number-format'
import { EditButton } from '~/components/DefaultLayout/Buttons/buttonStyle'
import MapView from '~/components/DataManipulation/Misc/Map'

const DetailsParentClient: React.FC = () => {
  const { parentCustomer, isLoading, setIsEdit } = useParentCustomer()

  const { deleteParentClient } = useListParentClients()

  const { Title, Text } = Typography

  if (isLoading || !parentCustomer) {
    return <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
  }

  return (
    <Container>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {parentCustomer.companyName}
          </Title>
        }
        extra={
          <Space>
            <EditButton icon={<EditOutlined />} onClick={() => setIsEdit(true)}>
              {translate('ClientsPrincipalTabsDetails.editButton')}
            </EditButton>
            <Popconfirm
              title={translate('ClientsPrincipalTabsDetails.deletePopConfirm')}
              onConfirm={() => deleteParentClient(parentCustomer._id)}
            >
              <Tooltip title="Deletar">
                <Button type="primary" danger icon={<DeleteFilled />} />
              </Tooltip>
            </Popconfirm>
          </Space>
        }
        style={{
          display: 'inline-block',
          width: '100%',
        }}
      >
        <>
          <Row>
            <Col span={12}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <AuditOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Razão Social / Nome
                  </Title>
                  {parentCustomer?.companyName ? (
                    <Text>{parentCustomer?.companyName}</Text>
                  ) : (
                    'Nenhuma informação disponível.'
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={12}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <ShopOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Nome Fantasia
                  </Title>
                  {parentCustomer?.fantasyName ? (
                    <Text>{parentCustomer?.fantasyName}</Text>
                  ) : (
                    'Nenhuma informação disponível.'
                  )}
                </div>
              </Flex>
            </Col>
          </Row>

          <Row style={{ marginTop: 14 }}>
            <Col span={12}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <IdcardOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    CNPJ
                  </Title>
                  {parentCustomer?.cnpj ? (
                    <Text>
                      <NumberFormat
                        value={parentCustomer?.cnpj}
                        displayType="text"
                        format="##.###.###/####-##"
                      />
                    </Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={12}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <IdcardOutlined
                      style={{ fontSize: 12, color: '#464545' }}
                    />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    CPF
                  </Title>
                  {parentCustomer?.cpf ? (
                    <Text>
                      <NumberFormat
                        value={parentCustomer?.cpf}
                        displayType="text"
                        format="###.###.###-##"
                      />
                    </Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>
          </Row>

          <Row style={{ marginTop: 14 }}>
            <Col span={12}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Inscrição Estadual
                  </Title>
                  {parentCustomer?.state_registration ? (
                    <Text>{parentCustomer?.state_registration}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={12}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <MailOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Inscrição Municipal
                  </Title>
                  {parentCustomer?.municipal_registration ? (
                    <Text>{parentCustomer?.municipal_registration}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>
          </Row>

          <Divider style={{ margin: '14px 0' }} />
          <Title level={5}>Dados Pessoais do Cliente</Title>
          <Row style={{ marginTop: 10 }}>
            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <UserOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Nome
                  </Title>
                  {parentCustomer?.contact?.name ? (
                    <Text>{parentCustomer?.contact?.name}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <MailOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Email
                  </Title>
                  {parentCustomer?.contact?.email ? (
                    <Text>{parentCustomer?.contact?.email}</Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>

            <Col span={8}>
              <Flex gap={10}>
                <Avatar
                  shape="square"
                  icon={
                    <PhoneOutlined style={{ fontSize: 12, color: '#464545' }} />
                  }
                  size="small"
                  style={{ background: '#DADADA' }}
                />
                <div>
                  <Title level={5} style={{ marginBottom: 0 }}>
                    Telefone
                  </Title>
                  {parentCustomer?.contact?.phone ? (
                    <Text>
                      <NumberFormat
                        value={parentCustomer?.contact.phone}
                        displayType="text"
                        format="(##) #####-####"
                      />
                    </Text>
                  ) : (
                    <Text>Nenhuma informação disponível.</Text>
                  )}
                </div>
              </Flex>
            </Col>
          </Row>
        </>
      </Card>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('ClientsPrincipalTabsDetails.addressCardTitle')}
          </Title>
        }
        style={{
          display: 'inline-block',
          width: '100%',
          marginTop: 15,
        }}
      >
        <Row gutter={12} style={{ marginTop: 10 }}>
          <Col span={6}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <PushpinOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.zipcodeText')}
                </Title>
                {parentCustomer?.address.zip_code ? (
                  <Text>{parentCustomer?.address.zip_code}</Text>
                ) : (
                  'Nenhuma informação disponível.'
                )}
              </div>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <HomeOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.addressText')}
                </Title>
                {parentCustomer?.address ? (
                  <Text>
                    {parentCustomer?.address.street},{' '}
                    {parentCustomer?.address.number} -{' '}
                    {parentCustomer?.address.neighborhood}
                  </Text>
                ) : (
                  'Nenhuma informação disponível.'
                )}
              </div>
            </Flex>
          </Col>
          <Col>
            <Flex gap={8}>
              <Avatar
                shape="square"
                icon={
                  <BankOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.cityText')}
                </Title>
                {parentCustomer?.address ? (
                  <Text>
                    {parentCustomer?.address.city} -{' '}
                    {parentCustomer?.address.state}
                  </Text>
                ) : (
                  'Nenhuma informação disponível.'
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <Row style={{ margin: '14px 0' }}>
          <Col span={6}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <PushpinOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('AddressList.complementText')}
                </Title>
                {parentCustomer?.address.complement ? (
                  <Text>{parentCustomer?.address.complement}</Text>
                ) : (
                  'Nenhuma informação disponível.'
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <MapView data={parentCustomer} isLoading={isLoading} />
      </Card>
    </Container>
  )
}

export default DetailsParentClient
